import { tyreBrandListQuerySchema } from '@chukua/common';
import { createTyreBrand, listTyreBrands } from '../tyres.api';
import { TyreCatalogueSelect } from './TyreCatalogueSelect';

const PAGE_SIZE = 20;

interface TyreBrandSelectProps {
  id?: string;
  value?: string;
  onChange?: (value: string | undefined) => void;
  savedName?: string | null;
  canAdd: boolean;
}

const fetchBrands = (q: string | undefined) =>
  listTyreBrands(tyreBrandListQuerySchema.parse({ q, isActive: 'true', pageSize: PAGE_SIZE })).then((page) => page.items);
const addBrand = (name: string) => createTyreBrand({ name });

export function TyreBrandSelect(props: TyreBrandSelectProps) {
  return <TyreCatalogueSelect {...props} fetch={fetchBrands} add={addBrand} noun="brand" />;
}
